import { authenticatedRequest } from './api.service';
import {
  PowerSkillQuestionsResponse,
  PowerSkillLastTestResponse,
  PowerSkillSubmitRequest,
  PowerSkillSubmitResponse,
  PowerSkillPdfStatusResponse, PowerSkillLastTestResponseFail
} from "../typings/powerskill";

export const powerSkillService = {
  getAllQuestions: async (
    randomize: boolean = true
  ): Promise<PowerSkillQuestionsResponse> => {
    const response = await authenticatedRequest(
      "GET",
      "/powerskill/questions/all",
      {
        randomize,
      }
    );
    return response as unknown as PowerSkillQuestionsResponse;
  },

  getLastTest: async (
    withCount: boolean = false
  ): Promise<PowerSkillLastTestResponse | PowerSkillLastTestResponseFail> => {
    try {
      const params = withCount ? { wc: 1 } : {};
      const response = await authenticatedRequest(
        "GET",
        "/powerskill/last-test",
        params
      );
      return {...response, status:true} as unknown as PowerSkillLastTestResponse;
    } catch (e: any){
      return {
        data: {
          countUser: e?.message?.data?.countUser,
        },
        status: false,
        message: e?.message?.message,
      };
    }
  },

  submitTest: async (
    answers: PowerSkillSubmitRequest
  ): Promise<PowerSkillSubmitResponse> => {
    const response = await authenticatedRequest(
      "POST",
      "/powerskill/submit-test",
      answers
    );
    return response as unknown as PowerSkillSubmitResponse;
  },

  generateAiRecommendation: async (testId: number): Promise<any> => {
    const response = await authenticatedRequest(
      "POST",
      `/powerskill/ai-recommendation/${testId}`
    );
    return response as unknown as any;
  },

  getTestById: async (testId: number): Promise<PowerSkillLastTestResponse> => {
    const response = await authenticatedRequest(
      "GET",
      `/powerskill/test/${testId}`
    );
    return response as unknown as PowerSkillLastTestResponse;
  },

  getPdfStatus: async (
    testId: number
  ): Promise<PowerSkillPdfStatusResponse> => {
    const response = await authenticatedRequest(
      "GET",
      `/powerskill/pdf-status/${testId}`
    );
    return response as unknown as PowerSkillPdfStatusResponse;
  },

  downloadPdf: async (testId: number): Promise<Blob> => {
    const response = await authenticatedRequest(
      "POST",
      `/powerskill/download-pdf/${testId}`,
      {},
      { responseType: "blob" }
    );
    return response as unknown as Blob;
  },
};
